import "../index.css";

import { child, get, getDatabase, ref } from "firebase/database";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ErrorMessage from "./ErrorMessage";
import { SectionControlForm } from "./SectionControlForm";
import { FaRegThumbsUp } from "react-icons/fa";

function LandingCard(props) {
  return (
    <div className="card">
      <div className="card-body d-flex justify-content-between flex-wrap">
        <div className="places-card-laptop">
          <div className="place-image">
            <img src={props.img} className="w-100 p-3 mr-1" alt={props.title} />
          </div>
          <div className="place-info p-3">
            <div>
              <h3 className="card-title">{props.title}</h3>
              <p>{props.description}</p>
            </div>
            <Link to={"/rent/" + props.uid}>
              <div
                className="landing-btn btn btn-secondary btn-lg"
                role="button"
              >
                View
              </div>
            </Link>
          </div>
          <FaRegThumbsUp size={21} />
          {props.thumbs}
        </div>
      </div>
    </div>
  );
}

export const Landing = () => {
  const [spaces, setSpaces] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(1000);
  const [minThumbs, setMinThumbs] = useState(0);

  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const db = getDatabase();
    get(child(ref(db), "/users"))
      .then((snapshot) => snapshot.val())
      .then((users) => {
        const spaces = [];
        Object.keys(users).forEach((uid) => {
          let user = users[uid];
          if (user && user.space) {
            spaces.push({
              owner: user.first_name,
              uid: uid,
              ...user.space,
            });
          }
        });
        setSpaces(spaces);
        setIsLoading(false);
      })
      .catch((err) => {
        setErrorMessage(err.message);
      });
  }, []);

  function filterSpaces(spacesList) {
    return spacesList.filter((space) => {
      return (
        space.price >= minPrice &&
        space.price <= maxPrice &&
        space.thumbs >= minThumbs
      );
    });
  }

  return (
    <main className="my-5 container">
      <ErrorMessage errorMessage={errorMessage} />
      <section className="d-sm-flex flex-sm-col">
        <SectionControlForm
          minPrice={minPrice}
          maxPrice={maxPrice}
          minThumbs={minThumbs}
          minPriceCallback={setMinPrice}
          maxPriceCallback={setMaxPrice}
          minThumbsCallback={setMinThumbs}
        />
        <div className="col-lg-9">
          <div>
            {isLoading ? null : (
              <div>
                <h1 className="p-3 text-center display-3">
                  {filterSpaces(spaces).length === 0
                    ? "no spaces near you"
                    : filterSpaces(spaces).length === 1
                    ? "1 space near you"
                    : filterSpaces(spaces).length + " spaces near you"}
                </h1>
              </div>
            )}
          </div>
          {!isLoading ? (
            filterSpaces(spaces).map((space) => {
              return (
                <LandingCard
                  uid={space.uid}
                  key={space.title + space.uid}
                  title={space.title}
                  description={space.description}
                  img={space.image}
                  owner={space.owner}
                  price={space.price}
                  thumbs={space.thumbs}
                />
              );
            })
          ) : (
            <p>Loading...</p>
          )}
        </div>
      </section>
    </main>
  );
};
